import { allCountries } from 'country-region-data'

export const countryOptions = allCountries.map((country) => ({
	label: country[0],
	value: country[1],
}))

export const stateOptions: { label: string; value: string }[] = [
	{ value: 'ACT', label: 'Australian Capital Territory (ACT)' },
	{ value: 'NSW', label: 'New South Wales (NSW)' },
	{ value: 'NT', label: 'Northern Territory (NT)' },
	{ value: 'QLD', label: 'Queensland (QLD)' },
	{ value: 'SA', label: 'South Australia (SA)' },
	{ value: 'TAS', label: 'Tasmania (TAS)' },
	{ value: 'VIC', label: 'Victoria (VIC)' },
	{ value: 'WA', label: 'Western Australia (WA)' },
]

export const today = new Date()

export const tomorrow = new Date(
	today.getFullYear(),
	today.getMonth(),
	today.getDate() + 1
)

export const dayAfterTomorrow = new Date(
	today.getFullYear(),
	today.getMonth(),
	today.getDate() + 2
)

export const oneMonthLater = new Date(tomorrow)
oneMonthLater.setMonth(oneMonthLater.getMonth() + 1)

export const threeMonthsLater = new Date(tomorrow)
threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3)
